import { useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaProfissionalAtendimentosListSearchComponent = () => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const { t } = useT()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    const protocolo = debouncedFilters.protocolo.trim()
    return protocolo ? `atendimento.protocolo~*${protocolo}*` : ''
  }, [debouncedFilters])

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  const activeFilters: ActiveFilter[] = filters.protocolo.trim()
    ? [
        {
          key: 'protocolo',
          label: t('protocolo.label'),
          value: `“${filters.protocolo.trim()}”`,
          onRemove: () => setFilter('protocolo', ''),
        },
      ]
    : []

  return (
    <TableFilters
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'atendimento na fatura' : 'atendimentos na fatura'}`
          }
        />
      }
    >
      <TableFilter label={t('protocolo.label')} wide>
        <Input
          entity='protocolo'
          value={filters.protocolo}
          onChange={(e) => setFilter('protocolo', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
